module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ve-125ee9246eea1cb1b6626f2cb1f335af.svg";